import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { Form, constantField, textBox } from "trader.ts/ui.forms";
import {
  evaluation_template_id,
  questiontype,
} from "../../../sql/classy/types";
import { makeArrayField } from "../../client/arrayfield";
import { renderSaveButton } from "../../client/savebutton";
import * as routes from "../../routes";
import { templateQuestionForm } from "../config_formulas/client";

export function render(opts: {
  template: {
    id: null | evaluation_template_id;
    label: string;
  };
  questions: {
    label: string;
    questiontype: questiontype;
    select_options: string[] | null;
  }[];
}): HTMLElement | HTMLElement[] {
  const form = new Form({})
    .addField("id", [], () => constantField(opts.template.id))
    .addField("label", [], () =>
      textBox({
        initialVal: opts.template.label,
        label: "Naam evaluatietype",
      }),
    )
    .addField("questions", [], async () => {
      return makeArrayField<{
        label: string;
        questiontype: questiontype;
        mandatory: boolean;
        select_options: string[] | null;
      }>({
        initialVal: opts.questions.map((q) => ({ ...q, mandatory: false })),
        // render: oneLineArrayRender((r) => r.label.trim() === "", {}),
        makeSubForm: async (question) => {
          return templateQuestionForm(question, {
            showMandatory: false,
            label: "Onderdeel",
          });
        },
        makeNew: () => ({
          label: "",
          questiontype: "text" as const,
          mandatory: true,
          select_options: [],
        }),
      });
    })
    .build();

  return (
    <div>
      <section>{form.render()}</section>
      <div style="text-align: right">
        {renderSaveButton({
          formS: form.s,
          save: async function (values) {
            const res = await rpc(
              routes.saveEvaluationTemplateSpec,
              undefined,
              values,
            );
            return {
              ...res,
              redirectUrl: routes.evaluation_templates_listRoute.link(),
              timeout: 1500,
            };
          },
          reload: false,
        })}
      </div>
    </div>
  );
}
